module.exports = __webpack_public_path__ + "003d61a34dbbaf266f38a99546450464.png";